export default __webpack_public_path__ + "static/media/no-report.1b3ac5da.svg";